<template>
  <i class="fab fa-staylinked" :class="{'color': color}"></i>
</template>
<script>
export default {
  props: {
    'color': {
      default: true
    }
  }
}
</script>
<style scoped lang="scss">
i.color {
  color: $white;
  font-size: 1rem;
}
</style>
